namespace GeniuzPOS.Administration {
    export interface UserForm {
        IsActive: Serenity.BooleanEditor;
        Username: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        ShopId: Serenity.LookupEditor;
        Roles: Serenity.LookupEditor;
        ApprGroupCode: Serenity.LookupEditor;
        MobilePhoneNumber: Serenity.StringEditor;
        MobilePhoneVerified: Serenity.BooleanEditor;
        TwoFactorAuth: Serenity.EnumEditor;
        UserImage: Serenity.ImageUploadEditor;
        Password: Serenity.PasswordEditor;
        PasswordConfirm: Serenity.PasswordEditor;
        Source: Serenity.StringEditor;
        UserActive: Serenity.EnumEditor;
        CheckPasswordUpdate: Serenity.DateEditor;
    }

    export class UserForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.User';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserForm.init)  {
                UserForm.init = true;

                var s = Serenity;
                var w0 = s.BooleanEditor;
                var w1 = s.StringEditor;
                var w2 = s.EmailAddressEditor;
                var w3 = s.LookupEditor;
                var w4 = s.EnumEditor;
                var w5 = s.ImageUploadEditor;
                var w6 = s.PasswordEditor;
                var w7 = s.DateEditor;

                Q.initFormType(UserForm, [
                    'IsActive', w0,
                    'Username', w1,
                    'DisplayName', w1,
                    'Email', w2,
                    'ShopId', w3,
                    'Roles', w3,
                    'ApprGroupCode', w3,
                    'MobilePhoneNumber', w1,
                    'MobilePhoneVerified', w0,
                    'TwoFactorAuth', w4,
                    'UserImage', w5,
                    'Password', w6,
                    'PasswordConfirm', w6,
                    'Source', w1,
                    'UserActive', w4,
                    'CheckPasswordUpdate', w7
                ]);
            }
        }
    }
}
